import {
  mapVenueOverviewVersionType,
  PermissionNameUnionType,
  useFindVenueOverviewVersionSuspense,
} from '@api';
import {
  EditActionIcon,
  TouringCard,
  TouringCardActions,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
} from '@common';
import { usePermissionContext } from '@hypeit-gmbh/hypeit-ui-core';
import { Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/venues/$id.overview.$version';
import {
  VenueInhouseTicketSystemForm,
  VenueInhouseTicketSystemTable,
} from './components';

export const VenueInhouseTicketSystem: React.FC = () => {
  const { t } = useTranslation('venueDetailsOverview');
  const [opened, { open: openModal, close: closeModal }] = useDisclosure(false);
  const { id, version } = Route.useParams();
  const { data: overviewVersion } = useFindVenueOverviewVersionSuspense(
    id,
    version,
    {
      query: {
        select: (data) => mapVenueOverviewVersionType(data.data),
      },
    }
  );
  const { hasPermission } = usePermissionContext<PermissionNameUnionType>();

  const userCanEditVenueInhouseTicketSystem = hasPermission({
    permission: 'VENUES_OVERVIEW',
    action: 'WRITE',
  });

  return (
    <>
      <TouringCard data-testid="venue-inhouse-ticket-system">
        <TouringCardHeader>
          <TouringCardTitle>
            {t('VENUE_INHOUSE_TICKET_SYSTEM.TITLE')}
          </TouringCardTitle>
          <TouringCardActions>
            {userCanEditVenueInhouseTicketSystem && (
              <EditActionIcon onClick={openModal} />
            )}
          </TouringCardActions>
        </TouringCardHeader>
        <TouringCardSection>
          <VenueInhouseTicketSystemTable
            venueInhouseTicketSystem={overviewVersion.inhouseTicketSystem}
          />
        </TouringCardSection>
      </TouringCard>
      <Modal
        opened={opened}
        onClose={closeModal}
        title={t('VENUE_INHOUSE_TICKET_SYSTEM.EDIT_MODAL_TITLE')}
      >
        <VenueInhouseTicketSystemForm
          venueId={id}
          overviewVersion={version}
          venueInhouseTicketSystem={overviewVersion.inhouseTicketSystem}
          onClose={closeModal}
        />
      </Modal>
    </>
  );
};
